import "./_input-field.scss"
import React, {useEffect, useState} from 'react';
import {Name} from "../../../../components";
import {saveSelector} from "../../../slices/NavigationSlice";
import {isFlowchartNameDuplicate, isValid} from "../../../validation/ValidationUtils";
import {useAppSelector} from "../../../../store/hooks";
import {getEstateFlowchartsSelector, selectedFlowchartIdSelector} from "../../../slices/EstateFlowChartSlice";
import {BASIC_DETAILS_CONSTANTS as Labels, VALIDATION_CONSTANTS as errors} from "../../../constants/LabelConstants";
import {selectReleaseToggles} from "../../../../ReleaseToggles/releaseTogglesSlice";
import {useParams} from "react-router-dom";
import {RouteWithIdAndFlowchartId} from "../../../../routes/types";

interface InputFieldProps {
    label: string;
    name: string | undefined | null;
    onChange: (name: string) => void;
    liveUpdate?: boolean;
    placeholder?: string;
    subText?: string;
    required?: boolean;
    autoComplete?: string;
    maxLength?: number;
}

function InputField({
                        label,
                        name,
                        liveUpdate = false,
                        onChange,
                        placeholder,
                        subText,
                        required = false,
                        autoComplete = "off",
                        maxLength
                    }: Readonly<InputFieldProps>) {

    const saveHasBeenClicked = useAppSelector(saveSelector);
    const [value, setValue] = useState<string>(name ?? "");
    const [hasError, setHasError] = useState<boolean>(false);
    const flowcharts = useAppSelector(getEstateFlowchartsSelector);
    const selectedFlowchartId = useAppSelector(selectedFlowchartIdSelector);
    const releaseToggles = useAppSelector(selectReleaseToggles);
    const {flowchartId} = useParams<RouteWithIdAndFlowchartId>();

    useEffect(() => {
        setValue(name ?? "");
    }, [name]);

    const isAdd = () => {
        const element = document.getElementById("form-header");
        const searchText = "Add";
        if (element && (element.textContent || element.innerText).includes(searchText)) {
            return true;
        } else {

            return false;
        }
    }

    const equalsOtherFlowchartNames = () => {
        return flowcharts.some(fc => {
            if (selectedFlowchartId !== undefined && selectedFlowchartId !== fc.flowchartId) {
                return fc.flowchartName?.toLowerCase() === value.toLowerCase();
            }
            return false;
        });
    }

    useEffect(() => {
        setHasError((required ?? false) && saveHasBeenClicked && !isValid(value));
        if(isValid(value) && label === Labels.FLOWCHART_NAME_LABEL_TEXT && releaseToggles?.enableEstateFlowchartMVPRelease){
            if (isAdd()) {
                if(flowchartId === 'new') {
                    //New Flowchart
                    setHasError(isFlowchartNameDuplicate(flowcharts, value));
                } else {
                    if (equalsOtherFlowchartNames()) {
                        //New Estate Item to existing flowchart, only validate if name belongs to some other flowchart
                        setHasError(isFlowchartNameDuplicate(flowcharts, value));
                    }
                }
            } else {
                if(equalsOtherFlowchartNames()) {
                    //Editing existing flowchart's item, only validate if name belongs to some other flowchart
                    setHasError(isFlowchartNameDuplicate(flowcharts, value));
                }
            }
        }
    }, [required, saveHasBeenClicked, value]);

    const isDuplicate = () => {
        if (label === Labels.FLOWCHART_NAME_LABEL_TEXT && releaseToggles?.enableEstateFlowchartMVPRelease) {
            if (isAdd()) {
                if (isFlowchartNameDuplicate(flowcharts, value || "")) {
                    return errors.DUPLICATE_FIELDS_FLOWCHART_NAME_TEXT;
                }
            } else {
                if (equalsOtherFlowchartNames()) {
                    if (isFlowchartNameDuplicate(flowcharts, value || "")) {
                        return errors.DUPLICATE_FIELDS_FLOWCHART_NAME_TEXT;
                    }
                }
            }
        }
        return undefined;
    }

    return (
        <div className="layout-data-entry-form__field input-field">
            <Name
                name={value ?? ''}
                label={label}
                aria-label={label}
                required={required}
                forceShowErrors={true}
                error={hasError ? (!isValid(value) ? `${label} is required.` : isDuplicate()) : undefined}
                onChange={(event) => {
                    setValue(event.target.value.trimStart());
                    if (liveUpdate) {
                        onChange(event.target.value.trimStart());
                    }
                }}
                placeholder={placeholder}
                whenUserHasInteracted={() => {
                    if(!liveUpdate) {
                        onChange(value);
                    }
                }}
                autoComplete={autoComplete}
                maxLength={maxLength}
            />
            {!hasError &&
                <span className="input__info margintop-sm">{subText}</span>
            }
        </div>
    );
}

export default InputField;